var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"admin-badge",class:`admin-badge--${_vm.color}`,style:(_vm.minWidth ? { minWidth: `${_vm.minWidth}px` } : null)},[(_vm.icon)?_c('q-icon',{attrs:{"name":_vm.icon,"size":"10px"}}):_vm._e(),_c('span',{staticClass:"admin-badge__label"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }